<template>
  <div class="box-forgot">
    <h2 class="forgot-title">Lost your password?</h2>
    <p class="text-reset">Enter your email address to create a new password.</p>
    <b-form
      style="text-align: left"
      ref="recoverPasswordForm"
      autocomplete="off"
      @submit.prevent="submitRecoverPassword"
    >
      <!-- E-mail Input -->
      <b-input-group class>
        <span class="formIcons email">
          <EmailIcon />
        </span>
        <b-form-input
          type="email"
          name="email"
          class="LoginInput"
          size="lg"
          placeholder="E-MAIL"
          v-model="$v.recoverPasswordForm.email.$model"
          @keypress="errors.recoveryEmail = false"
          :state="validateRecoveryEmail('email')"
          aria-describedby="email-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="email-feedback" v-bind:tooltip="false"
          >Must be a valid email address.</b-form-invalid-feedback
        >
      </b-input-group>
      <b-alert variant="error" v-model="errors.recoveryEmail"
        >This email is not associated with any account</b-alert
      >
      <b-alert variant="error" v-model="errors.network"
        >{{errors.networkMessage}}</b-alert
      >
      <button class="button-login" type="submit" id="submitRecoverPassword">
        <b-spinner v-show="showLoad"></b-spinner>
        <span id="button-text" v-if="!showLoad">Reset password</span>
      </button>
      <a href="https://dropsmart.io/support" class="support">Still having problems? Click here for more information.</a
      >
    </b-form>
  </div>
</template>

<script>
import EmailIcon from "./icons/EmailIcon.vue";

import { validationMixin } from "vuelidate";
import { FRONTEND_URL, BACKEND_URL } from "../config.js";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: validationMixin,
  components: {
    EmailIcon,
  },
  data() {
    return {
      webSupport: FRONTEND_URL.WebSupport,
      recoveryEmailWasSent: false,
      passwordRecoveryEmail: null,
      errors: {
        recoveryEmail: false,
        network: false,
        networkMessage: null,
      },
      showLoad: false,
      recoverPasswordForm: {
        email: null,
      },
    };
  },
  validations: {
    recoverPasswordForm: {
      email: {
        required,
        email,
      },
    },
  },
  mounted: function () {
    this.resetPasswordRecovery();
  },
  computed: {
    validRecoveryForm: function () {
      return !this.$v.recoverPasswordForm.$anyError;
    },
  },
  methods: {
    validateRecoveryEmail(name) {
      const { $dirty, $error } = this.$v.recoverPasswordForm[name];
      return $dirty ? !$error : null;
    },
    resetPasswordRecovery() {
      this.recoveryEmailWasSent = false;
      this.recoverPasswordForm.email = null;
      this.errors.recoveryEmail = false;
    },
    submitRecoverPassword() {
      this.$v.recoverPasswordForm.$touch();
      if (!this.validRecoveryForm) {
        return;
      }

      this.errors.network = false;
      this.errors.networkMessage = null;
      this.errors.recoveryEmail = false;

      let email = this.recoverPasswordForm.email;
      let url = BACKEND_URL.RecoverPasswordInfo + "?email=" + email;
      this.showLoad = true;
      fetch(url, {
        method: "POST",
        mode: "cors",
      })
        .then((response) => {
          if (response.ok) {
            this.recoveryEmailWasSent = true;
            this.passwordRecoveryEmail = email;
            this.$router.push({name: 'ResetFeedback', params: {customerEmail: this.recoverPasswordForm.email}});
          } else if (response.status == 404) {
            this.showLoad = false;
            this.recoveryEmailWasSent = false;
            this.errors.recoveryEmail = true;
          }
        })
        .catch((error) => {
          console.error(error);
          this.recoveryEmailWasSent = false;
          this.errors.network = true;
          this.errors.networkMessage = error.message;
          this.showLoad = false;
        });
    },
  },
};
</script>

<style lang="scss">
main {
  overflow-x: hidden;
  height: 100%;
}
.box-forgot {
  padding: 0 15px;
  text-align: center;
  .forgot-password {
    color: #666666;
    font-size: 13px;
    width: 100%;
  }
}
.forgot-title {
  color: #000000;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
.text-reset {
  color: #000000;
  font-size: 18px;
  margin: 0 auto;
  max-width: 360px;
  padding-top: 15px;
  text-align: center;
  margin-bottom: 30px;
}
.support {
  font-size: 14px;
  text-align: center;
  display: block;
  margin: 35px 0 30px;
  &:hover {
    color: #79b867;
  }
}
form {
  margin-bottom: 15px;
}
.button-login {
  background: #79b867;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 53px;
  margin-top: 8px;
  padding: 0 15px;
  text-transform: uppercase;
  width: 100%;
  .spinner-border {
    vertical-align: middle;
  }
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}
</style>